module.exports = __webpack_public_path__ + "img/634.14ed8949.jpg";